var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['map-palette-colors', _vm.isCurrent ? 'current' : '']},_vm._l((_vm.colors),function(color,i){return _c('div',{key:color + i,staticClass:"map-palette-colors__item",style:(("background-color: " + color))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }